import React from 'react';
import { useHubAppCopy } from '../../hooks';

interface CertificationHelpSubmittedModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueToPayment: () => void;
  loading?: boolean;
}

export const CertificationHelpSubmittedModal: React.FC<CertificationHelpSubmittedModalProps> = ({
  isOpen,
  onClose,
  onContinueToPayment,
  loading = false
}) => {
  const hubAppCopy = useHubAppCopy();
  const copy = hubAppCopy('portalCopy')?.subscriptionCopy?.certification?.helpSubmitted;

  if (!isOpen) return null;

  return (
    <div className="cert-modal-overlay" onClick={onClose}>
      <div className="cert-modal cert-modal--narrow" onClick={(e) => e.stopPropagation()}>
        <div className="cert-modal__header">
          <button
            className="cert-modal__close"
            onClick={onClose}
            aria-label={copy?.closeAriaLabel || 'Close modal'}
          >
            &times;
          </button>
        </div>

        <div className="cert-modal__body cert-modal__body--centered">
          <div className="cert-modal__success-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Envelope base */}
              <rect x="8" y="20" width="52" height="40" rx="4" stroke="#006C70" strokeWidth="2.5" fill="none"/>
              {/* Envelope flap */}
              <path d="M8 26L34 46L60 26" stroke="#006C70" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              {/* Checkmark circle */}
              <circle cx="58" cy="54" r="14" fill="#006C70"/>
              {/* Checkmark */}
              <path d="M51 54L56 59L66 49" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <h2 className="cert-modal__title">{copy?.title || 'Information Sent!'}</h2>

          <p className="cert-modal__description">
            {copy?.description || "Thanks for providing the extra details. You can go ahead and start your trial while we verify your Practitioner Program status. If we're unable to verify your eligibility, your trial and subscription will automatically lapse and you won't be charged."}
          </p>

          <button
            className="cert-modal__button cert-modal__button--primary"
            onClick={onContinueToPayment}
            disabled={loading}
          >
            {loading ? 'Processing...' : (copy?.continueButton || 'Continue to Payment')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertificationHelpSubmittedModal;
